<template>
  <div id="app" class="app-wrapper">
    <div class="app-inner">
      <HeaderView />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <FooterView />
    </div>
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
    this.preloadImages();
    this.setStats();
  },
  methods: {
    setStats() {
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = "https://eu.umami.is/script.js";
      scriptElement.dataset.websiteId = "f5ce1237-8860-4567-90e7-e30543474d2c";
      scriptElement.dataset.doNotTrack = "true";
      scriptElement.dataset.autoTrack = "true";
      document.body.append(scriptElement);
    },
    preloadImages() {
      const images = [
        require("@/assets/images/logo.svg"),
        require("@/assets/images/burger.png"),
        require("@/assets/images/home/goutez-aux-proteines-nouvelle-vague.svg"),
        require("@/assets/images/home/panneau2.png"),
        require("@/assets/images/home/vague2.jpg"),
        require("@/assets/images/done/game-left3.svg"),
        require("@/assets/images/done/centre.svg"),
        require("@/assets/images/done/fond.png"),
        require("@/assets/images/done/choice1.png"),
        require("@/assets/images/done/choice2.png"),
        require("@/assets/images/end/info.png"),
        require("@/assets/images/end/text.png"),
        require("@/assets/images/end/details.png"),
        require("@/assets/images/end/addr.png"),
      ];

      images.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style>
.app-wrapper {
  background-color: #ffffff;
}

.app-inner {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
